import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MakeAvatar } from './mixins';
var Avatar = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return MakeAvatar(props);
});
export var AvatarUser = function AvatarUser(_ref) {
  var src = _ref.src,
      size = _ref.size;
  return React.createElement(Avatar, {
    src: src,
    size: size
  });
};
AvatarUser.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number
};
AvatarUser.defaultProps = {
  size: 44
};